import { AppButton } from 'components/form';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import { t } from 'utilities/TranslationUtils';
import AppInfoFrame from "./AppInfoFrame";

type PropsType = {
  isDialogOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
  loadingStateTitle?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  message?: string;
  messageParameters?: {},
  info?: string;
  className?: string;
  footerNote?: string;
  isLoading?: boolean;
  dataTest?: string;
};

const AppConfirmDialog = ({
  isDialogOpen,
  onConfirm,
  onCancel,
  title = '',
  loadingStateTitle = '',
  confirmLabel = t('yes'),
  cancelLabel = t('no'),
  message = '',
  messageParameters = {},
  info = '',
  className = '',
  footerNote = '',
  isLoading = false,
  dataTest = '',
}: PropsType) => {
  const getTranslation = (label: string, params: {}) => {
    let result = t(label, params);

    const substrings = result.split("<<BR>>")
    let elementResult = (<>{substrings[0]}</>);
    for (let i = 1; i < substrings.length; i++) {
      elementResult = (<>{elementResult}<br />{substrings[i]}</>);
    }

    return elementResult;
  }
  return (
    <Dialog
      maxWidth={'xs'}
      fullWidth
      className={`app-confirm-dialog ${className}`}
      open={isDialogOpen}
      onClose={() => !isLoading && onCancel()}
      data-test={dataTest || 'testing-app-confirm-dialog'}
    >
      <>
        {isLoading ? (
          <div className='card'>
            <header className='p-3 border-bottom'>
              <h3 className='font-22 font-500 text-uppercase mb-0 text-uppercase font-22 font-500'>
                {loadingStateTitle || t('common.loading')}, {t('common.please_wait')}...
              </h3>
            </header>
            <div className='p-5 d-flex align-items-center justify-content-center'>
              <CircularProgress />
            </div>
          </div>
        ) : (
          <div className='card p-0'>
            <header className='p-3 border-bottom mb-0'>
              <h3 className='font-22 font-500 text-uppercase mb-0 text-uppercase font-22 font-500'>{title}</h3>
            </header>
            {message && (
              <div className='body card-body  p-3'>
                <p className='mb-0'>{getTranslation(message, messageParameters)}</p>
              </div>
            )}
            {info && (<AppInfoFrame message={t(info)} className='mb-4 mx-4 mt-0'/>)}
            <footer className='p-3 pb-0 border-top d-flex align-items-center justify-content-between'>
              <small className='text-danger'>{footerNote}</small>
              <div>
                <AppButton variant='secondary' onClick={() => onCancel()} data-test='testing-app-confirm-dialog-cancel-button'>
                  {cancelLabel}
                </AppButton>
                <AppButton
                  variant='danger'
                  className=' ml-2'
                  onClick={() => onConfirm()}
                  data-test='testing-app-confirm-dialog-confirm-button'
                >
                  {confirmLabel}
                </AppButton>
              </div>
            </footer>
          </div>
        )}
      </>
    </Dialog>
  );
};

export default AppConfirmDialog;
